import { useNavigate } from 'react-router-dom';
import { Button, Paragraph } from '@quickmd-llc/design-system';

const ID_VERIFICATION_STATES = [
  {
    label: 'Success',
    path: '/id-verification?isPurchaseFlow=true&forceResult=success',
  },
  {
    label: 'Tips (retry)',
    path: '/id-verification?isPurchaseFlow=true&forceTips=true',
  },
  {
    label: 'Contact Support',
    path: '/id-verification?isPurchaseFlow=true&forceTips=true&forceNoAttempts=true',
  },
] as const;

export function IdVerificationSection() {
  const navigate = useNavigate();

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        ID Verification (Purchase Flow)
      </Paragraph>

      <div className="flex flex-wrap gap-2">
        {ID_VERIFICATION_STATES.map(({ label, path }) => (
          <Button
            key={label}
            priority="secondary"
            size="s"
            onClick={() => navigate(path)}
          >
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
}
